import React, { useCallback, useEffect, useState } from "react";
import Map, { Marker } from "react-map-gl";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import { Typography } from "@mui/material";

const MapRunningClub = ({ runningClub, setOpen }) => {
  const mapRef = React.useRef();
  const [messageError, setMessageError] = useState("");
  const [viewport, setViewport] = useState({
    latitude: runningClub?.location[1] ?? 19.42847,
    longitude: runningClub?.location[0] ?? -99.12766,
    zoom: 17,
  });
  const centerMap = useCallback(() => {
    // console.log("Ubuicacion de running CLub", runningClub?.location);

    if (!mapRef.current) return;
    if (runningClub?.location) {
      mapRef.current.flyTo({
        center: runningClub?.location ?? [-99.12766, 19.42847],
        zoom: 17,
        duration: 1000,
      });
    }
  }, [runningClub]);

  useEffect(() => {
    if (!runningClub?.location && runningClub?.location.length === 0) {
      setMessageError("No se pudo obtener la unicación.");
    } else {
      centerMap();
    }
  }, [runningClub, centerMap]);

  if (!runningClub?.location && runningClub?.location.length === 0) {
    return <Typography>{messageError}</Typography>;
  }

  return (
    <Map
      {...viewport}
      ref={mapRef}
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
      mapStyle="mapbox://styles/mapbox/streets-v11"
      onMove={(evt) => setViewport(evt.viewState)}
    >
      {/* Ejemplo de un marcador */}
      {runningClub?.location && runningClub?.location.length > 0 && (
        <Marker
          latitude={runningClub?.location[1]}
          longitude={runningClub?.location[0]}
        >
          <PersonPinIcon sx={{ fontSize: 50, color: "black" }} />
        </Marker>
      )}
    </Map>
  );
};

export default MapRunningClub;
